import { jwtDecode } from 'jwt-decode';

import { decrypt, encrypt } from './LocalStorage';

type AuthTokenType = {
  accessToken: string;
  refreshToken: string;
};
export type TokenDecodeType = {
  email: string;
  exp: number;
  firstName: string;
  iat: number;
  id: string;
  lastName: string;
  refreshTokenId: string;
  roleId: 1;
  sat: number;
  tokenType: string;
};

class Storage {
  static KEYS = {
    AUTH_TOKEN: 'AUTH_TOKEN',
  };

  static setItem = (key: string, value: AuthTokenType | string): void => {
    if (!value) {
      value = '';
    }

    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(encrypt(key), encrypt(value));
  };

  static getItem = (key: string, shouldParse?: boolean): AuthTokenType => {
    const keyVal: any = decrypt(localStorage.getItem(Storage.searchKey(key)));

    if (shouldParse && keyVal) {
      return JSON.parse(keyVal);
    }

    return keyVal;
  };

  static searchKey(key: string): string {
    const keys = Object.keys(localStorage);
    let i = keys.length;

    while (i--) {
      try {
        if (decrypt(keys[i]) === key) {
          return keys[i];
        }
      } catch (e) {
        localStorage.removeItem(keys[i]);
      }
    }

    return '';
  }

  static removeItem = (key: string): void => {
    localStorage.removeItem(Storage.searchKey(key));
  };

  static clear = (): void => {
    localStorage.clear();
  };

  static getTokens = () => {
    try {
      const appAuth: any = Storage.getItem(Storage.KEYS.AUTH_TOKEN);
      return appAuth ? (JSON.parse(appAuth) as AuthTokenType) : null;
    } catch (e) {
      return null;
    }
  };

  // static getMenus = () => {
  //   try {
  //     const appMenu = Storage.getItem(Storage.KEYS.MENUS);
  //     return appMenu ? (JSON.parse(appMenu) as MenuType) : null;
  //   } catch (e) {
  //     return null;
  //   }
  // };

  static isTokenValidDetails = () => {
    const tokenData = Storage.getTokens();
    if (!tokenData || !tokenData.accessToken) {
      return false;
    }
    const userData: any = jwtDecode(String(tokenData.accessToken));
    if (!userData || (userData && userData.exp * 1000 < Date.now())) {
      return false;
    }
    return userData;
  };

  static updateAccessToken = ({ accessToken, refreshToken }: AuthTokenType) => {
    const tokenData = Storage.getTokens();
    tokenData.accessToken = accessToken;
    tokenData.refreshToken = refreshToken;
    Storage.setItem(Storage.KEYS.AUTH_TOKEN, JSON.stringify(tokenData));
  };

  static tokenDecode = (): TokenDecodeType => {
    const tokenData = Storage.getTokens();
    if (!tokenData || !tokenData.accessToken) {
      return null;
    }
    const userData: any = jwtDecode(tokenData.accessToken);
    if (!userData) {
      return null;
    }
    return userData;
  };
}

export default Storage;
